import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import NewBookingDuck from 'ducks/new-booking-duck';

const usePostSavingPoiCallback = () => {
  const dispatch = useDispatch();

  return useCallback(
    (deliveryID, dropOffIndex) => (newPOI, isDelete) => {
      const poi = {
        ...newPOI,
      };
      if (isDelete) {
        poi.label = undefined;
      }

      dispatch(
        NewBookingDuck.creators.updateDropOffInfo(
          deliveryID,
          dropOffIndex,
          poi,
        ),
      );
    },
    [dispatch],
  );
};

export default usePostSavingPoiCallback;
